import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';

import Button from '../common/inputs/button';

const SupervisorActions = props => {
  const {
    handleActionButtons, // function: To be called when clicking an action button
    revisionState
  } = props;
  return (
    <div className="supervisor_revision_panel_actions_wrapper">
      {revisionState != Constants.supervisorsAdmin.revisionStatus.APPROVED && (            
        <Button
          onClick={handleActionButtons}
          labelLocale={<FormattedMessage id="supervisorRevisionPanel.approveRevisionButtonLabel"/>}
          className={"approve_button"}
          data-action={Constants.supervisorsAdmin.revisionStatus.APPROVED}
        />
      )}
      {revisionState != Constants.supervisorsAdmin.revisionStatus.REJECTED && (
        <Button
          onClick={handleActionButtons}
          labelLocale={<FormattedMessage id="supervisorRevisionPanel.rejectRevisionButtonLabel"/>}
          className={"reject_button"}
          data-action={Constants.supervisorsAdmin.revisionStatus.REJECTED}
        />
      )}
      {revisionState != Constants.supervisorsAdmin.revisionStatus.NOT_REVIEWED && (            
        <Button
          onClick={handleActionButtons}
          labelLocale={<FormattedMessage id="supervisorRevisionPanel.notReviewedButtonLabel"/>}
          className={"null_revision_button"}
          data-action={Constants.supervisorsAdmin.revisionStatus.NOT_REVIEWED}
        />
      )}
    </div>
  );
};

export default SupervisorActions;



// WEBPACK FOOTER //
// ./source/client/components/supervisorRevisionPanel/supervisorActions.jsx